import BASE_URL from "../../config/api";
import React, { useState } from "react";
import { Upload, Form } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { BsCloudUpload, BsCheckCircle } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
const { Dragger } = Upload;

const CURRENT_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: 20 }, (_, i) => String(CURRENT_YEAR - i));

const AddConstruction = () => {
  const navigate = useNavigate();
  const [formFields, setFormFields] = useState({
    coverPhoto: "",
    title: "",
    description: "",
    location: "",
    status: "Ongoing",
    clientName: "",
    year: String(CURRENT_YEAR),
  });
  const [coverPhotoFileName, setCoverPhotoFileName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleCoverPhotoUpload = (file) => {
    if (file.file.status === "done") {
      const response = file.file.response;
      if (response?.success) {
        setFormFields((prev) => ({ ...prev, coverPhoto: response.data[0].bucket.data.url }));
        setCoverPhotoFileName(file.file.name);
        toast.success("Cover photo uploaded");
      } else {
        setCoverPhotoFileName("");
        toast.error("Upload failed");
      }
    } else if (file.file.status === "error") {
      setCoverPhotoFileName("");
      toast.error("Upload failed — network issue");
    }
  };

  const coverPhotoConfig = {
    name: "file",
    maxCount: 1,
    action: `${BASE_URL}/bucket/upload`,
    headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` },
    onChange: handleCoverPhotoUpload,
    showUploadList: false,
  };

  const submit = async () => {
    if (!formFields.coverPhoto) { toast.error("Please upload a cover photo"); return; }
    if (!formFields.title.trim()) { toast.error("Please enter a title"); return; }
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${BASE_URL}/construct/add-construction`, formFields, {
        headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` },
      });
      if (response.status === 200) {
        toast.success("Construction project created!");
        setTimeout(() => navigate(`/add-pictures/${response.data.data._id}`), 1200);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Submission failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  const inputClass = "w-full px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 text-sm focus:outline-none focus:ring-2 focus:ring-[#1877F2]/30 focus:border-[#1877F2] transition-colors";
  const labelClass = "block text-sm font-semibold text-gray-700 mb-1.5";

  return (
    <div>
      <ToastContainer />
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Add Construction Project</h1>
        <p className="text-gray-500 text-sm mt-1">Fill in the project details. You can add photos and videos after saving.</p>
      </div>

      <div className="max-w-2xl">
        <Form onFinish={submit} className="space-y-5">

          {/* Cover Photo */}
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
            <h2 className="text-sm font-bold text-gray-800 uppercase tracking-wide mb-4">Cover Photo</h2>
            <Form.Item name="coverPhoto" rules={[{ required: true }]} style={{ marginBottom: 0 }}>
              <Dragger {...coverPhotoConfig} className="!border-dashed !border-gray-300 !rounded-xl !bg-gray-50 hover:!border-[#1877F2] transition-colors">
                {coverPhotoFileName ? (
                  <div className="py-6 flex flex-col items-center gap-2">
                    <BsCheckCircle size={32} className="text-green-500" />
                    <p className="text-sm font-semibold text-gray-700">{coverPhotoFileName}</p>
                    <p className="text-xs text-gray-400">Click or drag to replace</p>
                  </div>
                ) : (
                  <div className="py-8 flex flex-col items-center gap-2">
                    <BsCloudUpload size={36} className="text-gray-400" />
                    <p className="text-sm font-semibold text-gray-600">Click or drag to upload</p>
                    <p className="text-xs text-gray-400">JPG, PNG, WebP</p>
                  </div>
                )}
              </Dragger>
            </Form.Item>
          </div>

          {/* Core Details */}
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 space-y-4">
            <h2 className="text-sm font-bold text-gray-800 uppercase tracking-wide">Project Details</h2>

            <div>
              <label className={labelClass}>Project Title *</label>
              <input required type="text" name="title" value={formFields.title}
                placeholder="e.g. Lekki Phase 2 Duplex" onChange={handleFieldChange} className={inputClass} />
            </div>

            <div>
              <label className={labelClass}>Description</label>
              <textarea name="description" value={formFields.description} rows={3}
                placeholder="Brief overview of the project…" onChange={handleFieldChange}
                className={`${inputClass} resize-none`} />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className={labelClass}>Location</label>
                <input type="text" name="location" value={formFields.location}
                  placeholder="e.g. Abuja, FCT" onChange={handleFieldChange} className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Client Name</label>
                <input type="text" name="clientName" value={formFields.clientName}
                  placeholder="e.g. Mr. Adebayo" onChange={handleFieldChange} className={inputClass} />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className={labelClass}>Status</label>
                <select name="status" value={formFields.status} onChange={handleFieldChange} className={inputClass}>
                  <option value="Ongoing">Ongoing</option>
                  <option value="Completed">Completed</option>
                </select>
              </div>
              <div>
                <label className={labelClass}>Year</label>
                <select name="year" value={formFields.year} onChange={handleFieldChange} className={inputClass}>
                  {YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
                </select>
              </div>
            </div>
          </div>

          <Form.Item style={{ marginBottom: 0 }}>
            <button type="submit" disabled={isSubmitting}
              className="bg-[#1877F2] hover:bg-[#0e5fc7] text-white font-bold px-8 py-3 rounded-xl transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed">
              {isSubmitting ? "Creating…" : "Create Project & Add Media →"}
            </button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default AddConstruction;
